import emailjs from "@emailjs/browser";
import { useState } from "react";
import { format } from "date-fns";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Divider from "@mui/material/Divider";
import AddIcon from "@mui/icons-material/Add";
import Leg from "./Leg";
import "../App.css";
import useAirports from "../hooks/useAirports";

const EMPTY_LEG = {
  from: "",
  to: "",
  dateFrom: null,
  dateTo: null,
  adults: 0,
  young: 0,
  kids: 0,
  infants: 0,
  carryOn: 0,
  holdLuggage: 0,
  skis: 0,
  golfBag: 0,
  others: 0,
  passengers: 1,
};

const TABS = {
  0: "Solo ida",
  1: "Ida y vuelta",
  2: "Multidestino",
};

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_USER_ID;
const THANK_YOU_PAGE = "https://southjets.sysgarage.com.ar/gracias/";

function Quoter({ handleResize }) {
  const [data, setData] = useState({
    legs: [{ ...EMPTY_LEG }],
    fullName: "",
    email: "",
    phone: "",
  });
  const [tabSelected, setTabSelected] = useState(0);
  const [errors, setErrors] = useState({});

  useAirports();

  const onTabChange = (newtab) => {
    if (newtab !== 2) {
      setData({ ...data, legs: [data.legs[0]] });
    }
    setTabSelected(newtab);
    handleResize();
  };

  const addDestination = () => {
    setData({ ...data, legs: [...data.legs, { ...EMPTY_LEG }] });
    handleResize();
  };

  const updateLeg = (index, newData) => {
    setErrors({});
    let aux = [...data.legs];
    aux[index] = newData;
    setData({ ...data, legs: [...aux] });
  };

  const removeLeg = (index) => {
    let aux = [...data.legs];
    aux.splice(index, 1);
    setData({ ...data, legs: [...aux] });
    handleResize();
  };

  const handleSend = () => {
    let newErrors = {};
    if (!data.email) {
      newErrors.email = true;
    }
    if (!data.phone) {
      newErrors.phone = true;
    }
    if (!data.fullName) {
      newErrors.fullName = true;
    }
    let legErrors = [];

    let message = `Tipo: ${TABS[tabSelected]}\n`;
    data.legs.forEach((leg, index) => {
      if (!leg.from) {
        legErrors[index] = { ...legErrors[index], from: true };
      }
      if (!leg.to) {
        legErrors[index] = { ...legErrors[index], to: true };
      }
      if (!leg.dateFrom) {
        legErrors[index] = { ...legErrors[index], dateFrom: true };
      }
      if (tabSelected === 2 && !leg.dateTo) {
        legErrors[index] = { ...legErrors[index], dateTo: true };
      }
      if (!leg.passengers) {
        legErrors[index] = { ...legErrors[index], passengers: true };
      }

      if (!legErrors[index] || Object.keys(legErrors[index]).length === 0) {
        message += `\nTRAMO ${index + 1}\n`;
        message += `Origen: ${
          leg?.from?.name ? `${leg?.from?.name} ${leg?.from?.iata}` : ""
        }\n`;
        message += `Destino: ${
          leg?.to?.name ? `${leg?.to?.name} ${leg?.to?.iata}` : ""
        }\n`;
        message += `Fecha de ida: ${
          leg?.dateFrom ? format(new Date(leg?.dateFrom), "dd/MM/yyyy") : ""
        }\n`;
        message += `Fecha de vuelta: ${
          leg?.dateTo ? format(new Date(leg?.dateTo), "dd/MM/yyyy") : ""
        }\n`;
        message += `Pasajeros: ${leg.passengers}\n`;
        // message += leg?.adults ? `\tAdultos: ${leg?.adults}\n` : "";
        // message += leg?.young ? `\tAdultos jóvenes: ${leg?.young}\n` : "";
        // message += leg?.kids ? `\tNiños: ${leg?.kids}\n` : "";
        // message += leg?.infants ? `\tBebés: ${leg?.infants}\n` : "";
      }
    });

    message += `\nEmail: ${data.email}\n`;
    message += `Teléfono: ${data.phone}`;

    if (legErrors.length) {
      newErrors.legs = legErrors;
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return;
    }

    emailjs
      .send(
        SERVICE_ID,
        TEMPLATE_ID,
        { message },
        {
          publicKey: PUBLIC_KEY,
        }
      )
      .then(
        function (response) {
          console.log("SUCCESS!", response.status, response.text);
          window.location.href = THANK_YOU_PAGE;
        },
        function (err) {
          console.log("FAILED...", err);
        }
      );
  };

  return (
    <div className="quoter-container">
      <div className="saj-container">
        {/* <Typography
          className="saj-title"
          variant="h6"
          color="#d5a459"
          sx={{ textAlign: "center", mb: 3 }}
        >
          Cotiza tu próximo vuelo
        </Typography> */}

        <Tabs
          value={tabSelected}
          onChange={(event, newValue) => onTabChange(newValue)}
          sx={{ minHeight: "40px", height: "40px" }}
          textColor="secondary"
          indicatorColor="secondary"
        >
          {Object.keys(TABS).map((key, index) => (
            <Tab label={TABS[key]} key={index} />
          ))}
        </Tabs>

        <div className="quoter-form">
          {data.legs.map((value, key) => (
            <div className="saj-content" key={key}>
              <Leg
                tabSelected={tabSelected}
                leg={value}
                updateLeg={(data) => updateLeg(key, data)}
                removeLeg={() => removeLeg(key)}
                removeDisabled={data.legs.length === 1}
                errors={errors.legs ? errors.legs[key] : undefined}
              />
            </div>
          ))}

          {tabSelected === 2 && data.legs.length < 5 && (
            <Grid container sx={{ paddingLeft: 1, paddingBottom: 1 }}>
              <Button
                onClick={addDestination}
                disabled={data.legs.length === 5}
                size="small"
                endIcon={<AddIcon />}
                color="secondary"
                variant="outlined"
                className="saj-outlined-btn"
              >
                Agregar tramo
              </Button>
            </Grid>
          )}

          <Divider sx={{ mt: 2, mb: 2 }}>Datos personales</Divider>

          <Grid container spacing={1} sx={{ padding: 1 }}>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                required
                label="Nombre y Apellido / Empresa"
                value={data.fullName}
                onChange={(e) => setData({ ...data, fullName: e.target.value })}
                size="small"
                fullWidth
                error={errors.fullName}
                variant="filled"
                color="secondary"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                required
                label="Email"
                value={data.email}
                onChange={(e) => setData({ ...data, email: e.target.value })}
                size="small"
                fullWidth
                error={errors.email}
                // helperText={errors.email ? "Campo obligatorio" : undefined}
                variant="filled"
                color="secondary"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                required
                label="Teléfono"
                value={data.phone}
                onChange={(e) => setData({ ...data, phone: e.target.value })}
                size="small"
                fullWidth
                error={errors.phone}
                // helperText={errors.phone ? "Campo obligatorio" : undefined}
                variant="filled"
                color="secondary"
              />
            </Grid>
            <Grid
              md={8}
              sx={{ display: { xs: "none", md: "block", lg: "none" } }}
            />
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Button
                id="main-btn"
                onClick={handleSend}
                fullWidth
                color="secondary"
                variant="contained"
              >
                Cotizar
              </Button>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
}

export default Quoter;
